import $ from "jquery";
import GLightbox from "glightbox";

$(window).on('load', function () {
	$(".glightbox").on("click", function (e) {
		e.preventDefault();
	});
	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
		description: 'data-description',
	});
});
